<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="100%"
    class="l4-full-screen-dialog"
  >
    <!-- 告警 Level 4 滿版樣式，出現時機：收到推播當下 -->
    <div id="BANotify_Level4_FullScreen">
      <div class="header">
        <el-button
          class="backBtn"
          @click="controlDialogVisible(false)"
        >
          <i class="icon-m-back" />
          <span>返回上一頁</span>
        </el-button>
      </div>
      <div class="content">
        <div class="notifyGroup">
          <div class="notify-area">
            <div class="notify" :class="{ 'disabled': !firstPublicBAData }">
              <div class="title">
                <div class="title-right">
                  <i class="icon-ba-public">
                    <i class="path1"></i>
                    <i class="path2"></i>
                    <i class="path3"></i>
                  </i>
                  <div class="warning-text">
                    公區告警：L4-災害級警報
                  </div>
                </div>
                <div v-if="firstPublicBAData && firstPublicBAData.data && firstPublicBAData.data.timeSince" class="time">
                  {{ firstPublicBAData.data.timeSince }}
                </div>
              </div>
              <template v-if="firstPublicBAData">
                <div class="message">
                  {{ firstPublicBAData.title }}
                </div>
                <div class="assetPosition">
                  <span class="assetPosition-title">設備位置：</span>
                  <span class="assetPosition-content">{{ firstPublicBAData.data.AssetPosition }}</span>
                </div>
                <div class="report">
                  <button class="reportBtn" @click="$openNewPageToPath({ name:'reportEventById', params: { id: firstPublicBAData.data.Id }, query: { area: 'public' }})">
                    前往回報
                    <i class="icon-m-next"></i>
                  </button>
                </div>
              </template>
              <template v-else>
                <div class="empty-notify-content">
                  目前無公區災害級警報事件
                </div>
              </template>
            </div>
          </div>
          <div class="notify-area">
            <div class="notify" :class="{ 'disabled': !firstPrivateBAData }">
              <div class="title">
                <div class="title-right">
                  <i class="icon-ba-private">
                    <i class="path1"></i>
                    <i class="path2"></i>
                    <i class="path3"></i>
                  </i>
                  <div class="warning-text">
                    私區告警：L4-災害級警報
                  </div>
                </div>
                <div v-if="firstPrivateBAData && firstPrivateBAData.data && firstPrivateBAData.data.timeSince" class="time">
                  {{ firstPrivateBAData.data.timeSince }}
                </div>
              </div>
              <template v-if="firstPrivateBAData">
                <div class="message">
                  {{ firstPrivateBAData.title }}
                </div>
                <div class="assetPosition">
                  <span class="assetPosition-title">位置：</span>
                  <span class="assetPosition-content">{{ firstPrivateBAData.data.AssetPosition }}</span>
                </div>
                <div class="report">
                  <button class="reportBtn" @click="$openNewPageToPath({ name:'reportPrivateEventById', params: { id: firstPrivateBAData.data.Id }})">
                    前往回報
                    <i class="icon-m-next"></i>
                  </button>
                </div>
              </template>
              <template v-else>
                <div class="empty-notify-content">
                  目前無私區災害級警報事件
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="to-more-group">
          <div class="to-more">
            <span v-if="publicBAData && publicBAData.length > 1" class="to-more-btn" @click="$openNewPageToPath({ name:'baEvent', query: { area: 'public' }})">
              查看其他 {{ publicBAData.length - 1 }} 則 <i class="icon-m-next"></i>
            </span>
          </div>

          <div class="to-more">
            <span v-if="privateBAData && privateBAData.length > 1" class="to-more-btn" @click="$openNewPageToPath({ name:'baEvent', query: { area: 'private' }})">
              查看其他 {{ privateBAData.length - 1 }} 則 <i class="icon-m-next"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      publicBAData: [], // 公區 array
      privateBAData: [], // 私區 array
      dialogVisible: false, // 是否顯示此 component
      updateDataTimer: null
    }
  },
  computed: {
    firstPublicBAData () {
      if (this.publicBAData && this.publicBAData.length > 0) return this.publicBAData[0]
      return null
    },
    firstPrivateBAData () {
      if (this.privateBAData && this.privateBAData.length > 0) return this.privateBAData[0]
      return null
    },
    rawPublicBAData () {
      return this.$store.state.localStorage['BA-alert']?.level4 || JSON.parse(localStorage.getItem('BA-alert'))?.level4 || []
    },
    rawPrivateBAData () {
      return this.$store.state.localStorage['BA-private-alert']?.level4 || JSON.parse(localStorage.getItem('BA-private-alert'))?.level4 || []
    },
    isAlarmEnabled () {
      return this.$store.getters.isServiceEnabled(24)
    },
    isShowL4FullScreen () {
      return this.isAlarmEnabled && this.dialogVisible && (this.publicBAData.length > 0 || this.privateBAData.length > 0)
    }
  },
  watch: {
    rawPublicBAData: {
      handler (newVal) {
        this.publicBAData = _cloneDeep(newVal)
      },
      immediate: true
    },
    rawPrivateBAData: {
      handler (newVal) {
        this.privateBAData = _cloneDeep(newVal)
      },
      immediate: true
    }
  },
  mounted () {
    // 監聽 service worker 訊息
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', this.onServiceWorkerMessage)
    }
  },
  destroyed () {
    // 取消監聽 service worker 訊息
    if (navigator.serviceWorker) {
      navigator.serviceWorker.removeEventListener('message', this.onServiceWorkerMessage)
    }
  },
  methods: {
    controlDialogVisible (value) {
      this.dialogVisible = value
      if (this.updateDataTimer) {
        clearInterval(this.updateDataTimer)
      }
      if (value) {
        this.updateDataTime()
      } else {
        clearInterval(this.updateDataTimer)
      }
    },
    setTimeSince () {
      if (this.publicBAData.length > 0) {
        this.publicBAData.forEach(item => {
          if (item.data.EventCreatedTime)
          { item.data.timeSince = this.$timeSince(item.data.EventCreatedTime) }
        })
      }
      if (this.privateBAData.length > 0) {
        this.privateBAData.forEach(item => {
          if (item.data.EventCreatedTime)
          { item.data.timeSince = this.$timeSince(item.data.EventCreatedTime) }
        })
      }
    },
    updateDataTime () {
      this.setTimeSince()
      this.updateDataTimer = setInterval(() => {
        this.setTimeSince()
      }, 60 * 1000)
    },
    onServiceWorkerMessage (event) {
      if (event.data && event.data.FeatureName === 'BA-alert' && parseInt(event.data.TagLevel) === 4) {
        this.controlDialogVisible(true)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.l4-full-screen-dialog
  z-index: 5000 !important
#BANotify_Level4_FullScreen
  width: 100vw
  height: 100vh
  background-color: #ee5858
  position: fixed
  top: 0
  left: 0
  box-sizing: border-box
  overflow: auto
  .header
    display: flex
    padding: 24px 60px 32px 40px
    position: sticky
    top: 0
    left: 0
    background-color: #ee5858
    z-index: 2
    .backBtn
      width: 193px
      height: 64px
      background-color: transparent
      border: 2px solid $white
      padding: 12px
      border-radius: 8px
      color: $white
      i
        font-size: 20px
        padding-right: 12px
      span
        color: $white
        font-size: 21px
        margin-right: 12px
    .sum
      color: $white
      flex: auto
      line-height: 64px
      font-size: 25px
      text-align: right
  .content
    display: flex
    flex-direction: column
    justify-content: center
    min-height: calc(100vh - 120px)
    height: auto
    .notifyGroup
      display: flex
      gap: 24px
      padding: 0 40px
      .notify-area
        width: 50%
        .notify
          background-color: $white
          border-radius: 24px
          padding: 28px 32px
          margin-bottom: 24px
          color: $mainFontColor
          &.disabled
            min-height: calc(100% - 80px)
            i::before,
            .warning-text
              color: $grayFontColor !important
            .empty-notify-content
              margin-top: 130px
              color: $grayFontColor
              font-size: 38px
              text-align: center
          .time
            color: #ee5858
            font-size: 27px
          .title
            display: flex
            justify-content: space-between
            align-items: center
            margin-bottom: 28px
            .title-right
              display: flex
              justify-content: right
              align-items: center
            .icon-ba-public,
            .icon-ba-private
              font-size: 80px
              vertical-align: middle
              margin-right: 12px
            .warning-text
              display: inline-block
              vertical-align: middle
              font-size: 35px
              font-weight: 600
              color: #ee5858
          .message
            +word-break-line(4)
            font-size: 43px
            line-height: 60px
            font-weight: 600
            margin-bottom: 20px
          .assetPosition
            line-height: 55px
            +word-break-line(5)
            .assetPosition-title
              font-size: 37px
            .assetPosition-content
              font-size: 39px
              font-weight: 600
          .report
            text-align: right
            .reportBtn
              margin-top: 80px
              position: relative
              background-color: #ee5858
              color: $white
              width: 300px
              height: 80px
              border-radius: 12px
              text-align: center
              font-size: 31px
              line-height: 80px
              outline: unset
              border: unset
              i
                position: absolute
                top: 28px
                right: 16px
                font-size: 24px
    .to-more-group
      display: flex
      justify-content: space-between
      align-items: center
      margin-top: 40px
      .to-more
        width: 100%
        text-align: center
        color: $white
        font-size: 36px
        .to-more-btn
          cursor: pointer
          display: flex
          justify-content: center
          align-items: center
          i
            font-size: 28px
            margin-left: 4px

</style>
